import { PropsWithChildren } from "react";
import { useBoardTemplatesModalProvider } from "@jugl-web/domain-resources/tasks/components/BoardTemplatesModal/providers/useBoardTemplatesModalProvider";
import { BoardTemplatesSidebar } from "./components/BoardTemplatesSidebar/BoardTemplatesSidebar";

export const BoardTemplatesLayout = ({ children }: PropsWithChildren) => {
  const { selectedTemplate } = useBoardTemplatesModalProvider();
  return (
    <div className="flex h-full flex-row overflow-hidden">
      {!selectedTemplate && (
        <div className="jugl__custom-scrollbar w-[320px] min-w-[320px] overflow-x-hidden overflow-y-auto border-0 border-r-[1px] border-solid border-dark-200">
          <BoardTemplatesSidebar />
        </div>
      )}
      <div className="h-full w-full overflow-y-auto">{children}</div>
    </div>
  );
};
